import styled, { css } from 'styled-components';

import Tooltip from 'components/utils/Tooltip';

import animations from 'styles/animations';
import colors from 'styles/colors';

export const Container = styled.div`
  margin-top: 0.5rem;
  position: relative;
  width: 100%;
`;

export const Label = styled.label`
  color: ${colors.gray300};
  display: flex;
  font-size: 0.75rem;
  margin-bottom: 0.5rem;
`;

export interface IFieldContainerProps {
  backgroundColor?: string;
  hasIcon?: boolean;
  height?: string;
  isErrored?: boolean;
  isFilled: boolean;
  isFocused: boolean;
  isReadOnly?: boolean;
  isSecure?: boolean;
}

export const FieldContainer = styled.div<IFieldContainerProps>`
  align-items: center;
  background: ${props =>
    props.backgroundColor ? props.backgroundColor : colors.white900};
  border: 1px solid ${colors.gray100};
  border-radius: 0.5rem;
  color: ${colors.gray200};
  display: grid;
  grid-template-columns: ${props => (props.isSecure ? '1fr 2rem' : '1fr')};
  height: ${props => (props.height ? props.height : '2.25rem')};
  min-width: 0;
  padding-left: 0.75rem;
  padding-right: ${props => (props.isSecure ? '.25rem' : '0')};
  position: relative;
  transition: all 0.3s ease;
  width: 100%;

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.red500};
      grid-template-columns: ${props.isSecure
        ? '1fr repeat(2, 2rem)'
        : ' 1fr 2rem'};
      padding-right: 0.25rem;

      ${props.hasIcon &&
      css`
        grid-template-columns: ${props.isSecure
          ? '2rem 1fr repeat(2, 2rem)'
          : '2rem 1fr 2rem'};
      `}
    `}

  ${props =>
    props.hasIcon &&
    css`
      grid-template-columns: ${props.isSecure || props.isErrored
        ? '2rem 1fr 2rem'
        : '2rem 1fr'};
      ${props.isErrored &&
      css`
        grid-template-columns: ${props.isSecure
          ? '2rem 1fr repeat(2, 2rem)'
          : '2rem 1fr 2rem'};
        padding-right: 0.25rem;
      `}
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: ${colors.cyan900};
      color: ${colors.cyan900};
    `}
  ${props =>
    props.isFilled &&
    css`
      color: ${colors.cyan900};
    `}
  ${props =>
    props.isReadOnly &&
    css`
      background-color: ${colors.background};
      border-color: ${colors.background};
    `}
`;

export interface IInputProps {
  isLoading?: boolean;
  textAlign?: string;
  uppercase?: boolean;
}

export const Input = styled.input<IInputProps>`
  background: ${colors.transparent};
  border: 0;
  border-radius: 0.5rem;
  color: ${colors.gray500};
  flex: 1;
  font-size: 0.85rem;
  height: 100%;
  max-width: 100%;
  min-width: 0px;
  padding-right: ${props => (props.textAlign === 'right' ? '.7rem' : 0)};
  text-align: ${props => (props.textAlign ? props.textAlign : 'initial')};
  &:read-only {
    cursor: not-allowed;
  }
  ${props =>
    props.isLoading &&
    css`
      animation: ${animations.shimmer} 2s infinite linear;
      background: linear-gradient(
        to right,
        #f2f3f5 4%,
        #ebeced 25%,
        #f2f3f5 36%
      );
      background-size: 1000px 100%;
      cursor: not-allowed;
    `}
  ${props =>
    props.uppercase &&
    css`
      text-transform: uppercase;
    `}
  &::-webkit-calendar-picker-indicator {
    margin-right: 0.5rem;
  }
`;

export const ToggleSecure = styled.div`
  align-items: center;
  background: ${colors.transparent};
  border: 0;
  color: ${colors.gray200};
  display: flex;
  font-size: 0;
  height: 2rem;
  justify-content: center;
  outline: none;
`;

export const Error = styled(Tooltip)``;
